const URL_API_CalcTax = process.env.REACT_APP_URL_API_CalcTax

const HTTP_METHODS = { GET: "GET", POST: "POST", PUT: "PUT", DELETE: "DELETE" }
const APIS = { DORA: URL_API_CalcTax }

async function callEndpoint(api, httpMethod, endpoint, bodyData, setShowMessages, authorization = false)
{
    if (!Object.values(APIS).includes(api)) { console.log(`Erro ao tentar chamar api: api ${api} não existe`) ; return }
    if (!Object.values(HTTP_METHODS).includes(httpMethod)) { console.log(`Erro ao tentar chamar api: método HTTP ${httpMethod} não existe`) ; return }

    if (httpMethod === HTTP_METHODS.POST && !bodyData) { console.log("Aviso: chamando um método POST com body indefinido") }
    
    const url = api + endpoint
    const reqOpts =
    {
        method: httpMethod,
        headers:
        {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(bodyData)
    }

    let response
    try
    {
        console.log(`Chamando ${api}${endpoint}`)
        response = await fetch(url, reqOpts)
        console.log(response)
        if (setShowMessages && setShowMessages.success) { setShowMessages.success(true) }
    }
    catch(error)
    {
        if (setShowMessages && setShowMessages.error) { setShowMessages.error(true) }
        console.log(`Erro ao chamar o endpoint: ${error}`)
        throw error
    }

    if (response?.ok)
    {
        return response
    }
    else
    {
        const erro = await response.text()
        throw new Error(erro)
    }
}

export async function CalcTax(idServ, inputData, version, setShowMessages)
{
    try 
    {
        if (!inputData.edif) {
            inputData.edif = {}
        }
        inputData.edif.tipo = inputData.tipo || "Uniresidencial"

        const result = await callEndpoint(APIS.DORA, HTTP_METHODS.POST, `calc${idServ}${version}`, inputData, setShowMessages)
        return result.json()
    }
    catch (error)
    {
        return { "error": error.message }
    }
}
